import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { CircularProgress, Dialog, Slide } from "@mui/material";

import { Logout as LogoutIcon } from "@mui/icons-material";
import logo from "../../images/logo.png";
import "../../css/close-session.css";
import { useRouterStore } from "../../../libs/stores";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface DialogCloseSessionProps {
  open: boolean;
  handleClose: () => void;
}
export const DialogCloseSession = ({
  open,
  handleClose,
}: DialogCloseSessionProps) => {
  const navigate = useNavigate();
  const reset = useRouterStore((state) => state.reset);
  const firstName = useRouterStore((state) => state.firstName);
  const [isClosing, setClosing] = useState(false);
  const [isContinuo, setContinuo] = useState(false); 

  useEffect(() => {
    if (isContinuo) {
      handleCloseSession();
    }
  }, [isContinuo]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCloseSession = () => {
    reset();
    localStorage.removeItem(process.env.REACT_APP_TOKEN!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_OPTIONS!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_ROUTER!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_ROUTER_BACKUP!);


    setTimeout(() => {
      navigate("/", { replace: true });
      setClosing(false);
      handleClose();
    }, 2000);
  };

  const handleContinuo = () => {
    setClosing(true);
    setTimeout(() => {
      setContinuo(true);
    }, 1000);
  };

  return (
    <Dialog
      open={open}
      onClose={isClosing ? undefined : handleClose}
      maxWidth="sm"
      TransitionComponent={Transition}
      aria-labelledby="form-dialog-title"
      className="csd"
      BackdropProps={{
        style: { backgroundColor: "rgba(11, 13, 11, 0.85)" },
      }}
    >
      <div className="csd-header">
        <div className="csd-logo">
          <img src={logo} alt="MALIMAX" />
        </div>
        <div>
          <p className="csd-eyebrow">MALIMAX Security</p>
          <h3 className="csd-title" id="form-dialog-title">
            Cerrar sesión
          </h3>
        </div>
      </div>
      <div className="csd-body">
        {firstName ? <strong>{firstName}, </strong> : null}
        ¿está seguro que desea salir del sistema? Tendrá que iniciar sesión
        nuevamente para continuar.
      </div>
      <div className="csd-footer">
        <button
          type="button"
          className="csd-btn csd-btn-secondary"
          onClick={handleClose}
          disabled={isClosing}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="csd-btn csd-btn-primary"
          onClick={handleContinuo}
          disabled={isClosing}
        >
          {isClosing ? (
            <CircularProgress size={16} sx={{ color: "#25D228" }} />
          ) : (
            <LogoutIcon sx={{ fontSize: 18, color: "#25D228" }} />
          )}
          {isClosing ? "Saliendo..." : "Salir"}
        </button>
      </div>
    </Dialog>
  );
};
